<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
            User Roles & Permissions
        </div>


        <div class="flex justify-end">
            <button class="btn btn-outline" (click)="addRolesModal()">Create Roles </button>

            <div class="w-18 mx-4">
                <mat-form-field class="w-full">
                    <mat-select [(ngModel)]="filterData.pageSize" (selectionChange)="getRolesDetails()">
                        <mat-option [value]="10"> 10 </mat-option>
                        <mat-option [value]="20"> 20 </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-form-field class="w-48">
                <input matInput placeholder="Search Role">
                <mat-icon [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
            </mat-form-field>
        </div>

        <div class="overflow-x-auto">
            <table class="table table-zebra text-center">
                <thead class="header">
                    <tr class="text-center tableHeader-bg-color">
                        <td class="w-12"> No </td>
                        <td> Roles </td>
                        <td> Email </td>
                        <td> Permission </td>
                        <td> </td>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="(roleDetails$ | async) as roleDetails; else noData">
                        <ng-container *ngFor="let data of roleDetails.data.data, let i = index">
                            <tr>
                                <td>{{ i + 1}}</td>
                                <td>{{ data.role }}</td>
                                <td>
                                    <ng-container *ngFor="let email of data.email">
                                        <div class="badge">{{ email }}</div>
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngFor="let permission of data.permissions,">
                                        <div class="badge badge-custom-primary">{{ permission }}</div>
                                    </ng-container>
                                </td>
                                <td>
                                    <button class="btn btn-remove-bg mx-5" (click)="editRoleModal(data)">
                                        <mat-icon style="color:#FFC300"
                                            [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>


                    <!-- TODO: USING DUMMY DATA - TO BE DELETED -->
                    <!-- <ng-container *ngFor="let data of dummyData, let i = index">
                        <tr>
                            <td>{{ i + 1}}</td>
                            <td class="text-left">{{ data.role }}</td>
                            <td>
                                <ng-container *ngFor="let email of data.email">
                                    <div class="badge">{{ email }}</div>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngFor="let permission of data.permissions">
                                    <div class="badge badge-custom-primary">{{ permission }}</div>
                                </ng-container>
                            </td>
                            <td>
                                <button class="btn btn-remove-bg mx-5" (click)="editRoleModal(data)">
                                    <mat-icon style="color:#FFC300"
                                        [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                </button>
                            </td>
                        </tr>
                    </ng-container> -->
                </tbody>

                <ng-template #noData>
                    <tr>
                        <td style="background-color: #f5f5f5;" colspan="10">No data available</td>
                    </tr>
                </ng-template>
            </table>
        </div>

        <!-- pagination -->
        <div class="divider mt-2"></div>
        <div class="join flex justify-between w-full">
            <button class="join-item btn btn-remove-bg"  [disabled]="filterData.pageNumber <= 1" (click)="previousPage()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
                Previous</button>
            <button class="join-item">Page 1</button>
            <button class="join-item btn btn-remove-bg" [disabled]="(roleDetails$ | async)?.data.totalPages <= filterData.pageNumber" (click)="nextPage()">
                Next
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-right'"></mat-icon>
            </button>
        </div>
    </div>
</div>